export default __webpack_public_path__ + "68bc392e2931f3d7c64fa4d50d46d755.svg";